import { defineComponent as _defineComponent } from 'vue'
import {
  EventData,
  MapMouseEvent,
  MapboxGeoJSONFeature,
  AnyLayer,
} from 'mapbox-gl'
import { Geometry, Feature, FeatureCollection } from 'geojson'
import LocationDTO from '@/models/location'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { computed } from 'vue'
import { locationPinStyle } from './styles/location-pin'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsModifiedLayer',
  props: {
    layerId: null,
    sourceId: null,
    showLocations: null,
    hideLocations: null,
    before: null,
    hideLayer: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    event: 'click',
    data: MapboxGeoJSONFeature[],
    eventData: MapMouseEvent & EventData
  )
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  layerId: string
  sourceId: string
  showLocations?: LocationDTO[]
  hideLocations?: LocationDTO[]
  before?: string
  hideLayer?: boolean
}





const handleClick = (
  data: MapboxGeoJSONFeature[],
  eventData: MapMouseEvent & EventData
) => {
  emits('click', data, eventData)
}

const data = computed<FeatureCollection<Geometry>>(() => {
  const features =
    props.showLocations?.map<Feature>((location: LocationDTO) => ({
      id: location.id ?? undefined,
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [location.longitude!, location.latitude!],
      },
      properties: {
        Name: location.location,
        Icon: location.icon,
        IconColor: location.locationStatusColorHexCode,
        OwnerId: location.ownerId,
      },
    })) ?? []

  return {
    type: 'FeatureCollection',
    features,
  }
})

const filter = computed(() => {
  const arr: any[] = ['all']
  const ids = props.hideLocations?.map((l) => l.id) ?? []

  if (ids.length > 0) {
    arr.push(['!', ['in', ['id'], ['literal', ids]]])
  }

  return arr
})

const layers: AnyLayer[] = [
  {
    id: props.layerId,
    source: props.sourceId,
    type: 'symbol',
    layout: {
      ...locationPinStyle.layout,
    },
    paint: {
      ...locationPinStyle.paint,
    },
  },
]

return { __sfc: true,props, emits, handleClick, data, filter, layers, GeoJsonSource, LayerGroup }
}

})